export const RENTER_AGE_OPTIONS = [
  { value: 25, label: '25+' },
  { value: 21, label: '21-24' },
];

export const DEFAULT_MINIMUM_AGE = 25;
